import TagPicker from "@/components-legacy/tagPicker";
import useShop from "@babackapp/private-api-client/client/use-shop";
import { WorkflowStepDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { PlusIcon } from "@heroicons/react/24/outline";
import { LightningBoltIcon } from "@radix-ui/react-icons";
import { useParams } from "react-router-dom";
import { Handle, Position } from "reactflow";
import UserPicker from "../../hooks/user-picker";

export default function TriggerNode(props: {
  data: {
    step: WorkflowStepDto;
    onSelect: (step: WorkflowStepDto) => void;
    onDelete: (stepId: string) => void;
    isSelected: boolean;
    label: string;
  };
}) {
  const { shopId } = useParams<{ shopId: string }>();
  const { data: shop } = useShop(shopId);

  const t = useTranslation();
  const tags = ["Quality", "To check", "Out of stock"];
  if (!shop) {
    return <></>;
  }

  const nbFilter =
    (props.data.step.parameters.reason
      ? props.data.step.parameters.reason.length
      : 0) +
    (props.data.step.parameters.status
      ? props.data.step.parameters.status.length
      : 0) +
    (props.data.step.parameters.resolution
      ? props.data.step.parameters.resolution.length
      : 0);

  const operationMapping = {
    "returnRequest:returnRequest:create": "workflow.module.isCreated",
    "returnRequest:returnRequest:cancel": "workflow.module.isCanceled",
    "returnRequest:assignee:update": "workflow.module.isAssigned",
    "returnRequest:tags:update": "workflow.module.isTags",
    "returnRequest:merchant:treat": "workflow.module.isTreatedMerch",
    "returnRequest:merchant:fakeTreat": "workflow.module.isFakeTreatedMerch",
    "returnRequest:treatment:error": "workflow.module.errorWhen",
    "returnRequest:status:update": "workflow.module.changeStatus",
    "returnRequest:logistician:treat": "workflow.module.isTreatedLogi",
    "returnRequest:need:approval": "workflow.module.needApprovalTrigger",
    "returnRequest:logistician:reject": "workflow.module.isRejected",
    "returnRequest:merchant:reject": "workflow.module.isRejected",
  } as const;

  type OperationKey = keyof typeof operationMapping;
  const getOperationText = (operationKey: OperationKey) => {
    if (operationKey === "returnRequest:status:update") {
      return `${t(operationMapping[operationKey])} ${t(props.data.step.parameters.status[0])}`;
    }

    const translationKey = operationMapping[operationKey] || null;
    return translationKey ? t(translationKey) : null;
  };

  return (
    <div
      onClick={() => {
        props.data.onSelect(props.data.step);
      }}
    >
      <div
        className={` bg-white p-4 rounded-md w-80 hover:shadow-md transition-shadow transition-duration-100 cursor-pointer font-normal text-sm ${
          props.data.isSelected ? "ring-2 ring-purple-500" : ""
        }`}
      >
        <div className="rounded-md  space-y-2 ">
          <div className="flex text-gray-400 items-center justify-between">
            <div className=" space-x-1  items-center flex">
              <LightningBoltIcon className="w-4 h-4" />
              <div className="">{t("workflow.module.trigger")}</div>
            </div>
          </div>
          <div className="">
            <span className="text-gray-400">{t("workflow.module.when")}</span>
            <span className="text-gray-700 px-1">
              {getOperationText(props.data.step.operation as OperationKey)}
            </span>
          </div>
        </div>

        {props.data.step.operation == "returnRequest:assignee:update" ? (
          <div>
            <div className="pb-2"> {t("workflow.module.userAssigned")}</div>
            <UserPicker
              readOnly={true}
              usersPicked={props.data.step.parameters.users}
              onUpdateUser={() => {}}
            />
          </div>
        ) : props.data.step.operation == "returnRequest:tags:update" ? (
          <div className="flex space-x-2">
            <div> {t("workflow.module.tagTagged")}</div>
            <TagPicker
              readOnly={true}
              tags={tags}
              onUpdateTag={() => {}}
              tagsPicked={[props.data.step.parameters.tags || ""]}
            />
          </div>
        ) : (
          <></>
        )}

        {nbFilter > 0 && (
          <div className="flex items-center">
            <PlusIcon className="w-4 h-4 text-gray-500 mr-1" />
            <div className="pr-1 text-gray-500"> {nbFilter}</div>
            {nbFilter > 1 ? (
              <div className="text-gray-400">Filters</div>
            ) : (
              <div className="text-gray-400">Filter</div>
            )}
          </div>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id={props.data.step.id}
      />
    </div>
  );
}
